import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { BUTTONS, MODALS, POST } from 'locales/locales'
import { INewsFeedSlice, newsFeedActions, setCommentData } from 'app/slices/news-feed.slice'
import {
  useDeletePostMutation,
  useDislikePostMutation,
  useLazyGetJumpedCommentsQuery,
  useLazyGetCommentsOfPostQuery,
  useLikePostMutation,
} from 'app/services/post.service'
import { FixMeLater } from 'types'
import { findLikeAndDislike } from 'utils/helpers/postHelper'
import styled from 'styled-components'
import colors from 'utils/colors'

import Separator from 'components/separator/Separator'
import Post from '../post/Post'
import PostReactions from '../_components/post-reactions/PostReactions'
import useInfoModal from 'utils/hooks/useInfoModal'
import Comments from '../post/comments/Comments'
import CommonInput from '../_components/common-input/CommonInput'
import EditPost from '../edit-post/EditPost'
import Avatar, { AvatarSize } from 'components/avatar/Avatar'
import useCreatePostInput from 'utils/hooks/useCreatePostInput'
import { MOBILE_DEVICE_WIDTH } from 'utils/constants'
import useWindowDimensions from 'utils/hooks/useWindowDimensions'
import { useOutletNewsFeedState } from 'utils/hooks/useOutletState'
import Header from '../_components/header/Header'
import _ from 'lodash'
const PostDetail = () => {
  const { postId = '' } = useParams()
  const { t } = useTranslation()
  const { screenWidth } = useWindowDimensions()
  const myId = useAppSelector((state) => state.auth.id)
  const authUser = useAppSelector((state) => state.auth.user)
  const statePosts = useAppSelector((state) => state.newsFeed.posts)

  const [reactions, setReactions] = useState({ visible: false, postId: '' })
  const [readyToScrollComment, setReadyToScrollComment] = useState(true)
  const { isCommentLoading, commentInputData, commentPageIndex, isPostLoading }: INewsFeedSlice =
    useAppSelector((state) => state.newsFeed)

  const [comments, setComments] = useState<FixMeLater>([])
  const [likePost] = useLikePostMutation()
  const [dislikePost] = useDislikePostMutation()
  const [mentionsDropdown, setMentionsDropdown] = useState(false)
  const [pageNumber, setPageNumber] = useState(0)
  // const [getPost] = useLazyGetPostByIdQuery()

  const [post, setPost] = useState<FixMeLater>(statePosts.find((post: any) => post._id === postId))

  const [getComments] = useLazyGetCommentsOfPostQuery()
  const [totalCommentCount, setTotalCommentCount] = useState(0)
  const [editPost, setEditPost] = useState<FixMeLater>({ visible: false, post: null })
  const [deletePost] = useDeletePostMutation()
  const dispatch = useAppDispatch()

  

  const {
    newsFeedJumpData,
    onResetNewsFeedJumpData,
    onJumpComment,
    onCloseNotification,
    onToggleNotification,
    openNotifications,
    
  } = useOutletNewsFeedState()

  const { openModal, closeModal, Modal } = useInfoModal()

  const { isValid, onNewCommentForPost, onSelectEmoji, onChangeInputData } = useCreatePostInput({
    inputData: commentInputData?.[postId],
    postId,
  })

  useEffect(() => {
    const _getData = async () => {
      await fetchData()
    }
    _getData()
  }, [])



  const fetchData = async (isRefresh = false) => {
    try {

      const resultComment = await getComments({ postId, page: pageNumber })
      setTotalCommentCount(resultComment.data.totalCount)

      if (!resultComment.isError) {
        setTotalCommentCount(resultComment.data.totalCount)
        let commentsToSet = resultComment.data.data
  
        if (!isRefresh) {
          commentsToSet = [...comments, ...commentsToSet]
        }
        const uniqueComments = _.uniqBy(commentsToSet, (cmnt: any) => cmnt._id)
        setComments(uniqueComments)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchJumpedComments = async () => {
    const { data: result }: FixMeLater = await jumpToComment({
      postId: newsFeedJumpData.postId,
      commentId: newsFeedJumpData?.commentId, // new response including typeId as commentId
    })
    if (result) {
      const { page, data, totalCount } = result
      setTotalCommentCount(totalCount)
      setComments(data.map((comment: FixMeLater) => setCommentData(comment)))
      setPageNumber(page)
      setReadyToScrollComment(false)
    }
  }

  const onShowReactions = (postId: string) => {
    setReactions({ visible: true, postId })
  }

  const onHideReactions = () => {
    setReactions({ visible: false, postId: '' })
  }

  const onConfirmDeletePost = async (postId: string) => {
    try {
      const result: FixMeLater = await deletePost({ postId })
      if (!result.error) {
        dispatch(newsFeedActions.deletePost({ postId }))
      }
    } finally {
      closeModal()
    }
  }

  const onShowEditPostModal = (postId?: string) => {
    if (postId) {
      setEditPost({ visible: true, post: comments.find((item: FixMeLater) => item._id === postId) })
      return
    }
    setEditPost({ visible: true, post })
  }

  const onDeletePost = (postId: string) => {
    openModal({
      title: t(MODALS.DELETE_POST_TITLE),
      description: t(MODALS.DELETE_POST_DESCRIPTION),
      okTitle: t(BUTTONS.DELETE) as string,
      onCancel: closeModal,
      onOk: () => onConfirmDeletePost(postId),
    })
  }

  const onHideEditPostModal = () => {
    setEditPost({ visible: false, post: null })
  }

  const onKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {

    if (mentionsDropdown) return

    event.key === 'Enter' && !event.shiftKey && event.preventDefault()

    if (event.key === 'Enter' && isValid && !event.shiftKey) {
      onNewComment()
    }
  }

  const onReactionPost = async (postId: string, isLike: boolean) => {
    if (isLike) {
      likePost({ postId, myId })
    } else {
      dislikePost({ postId, myId })
    }
    const { likeData, dislikeData } = findLikeAndDislike(isLike, post, myId)
    setPost({ ...post, likes: likeData, dislikes: dislikeData })
    dispatch(
      newsFeedActions.updateLikeCount({ type: isLike ? 'increase' : 'descrease', myId, postId }),
    )
  }

  const onConfirmDeleteComment = async (postId: string) => {
    try {
      const result: FixMeLater = await deletePost({ postId })
      if (!result.error) {
        const filteredComment = comments.filter((item: FixMeLater) => item._id !== postId)
        setComments(filteredComment)
        setTotalCommentCount((prev) => prev - 1)
      }
    } finally {
      closeModal()
    }
  }

  const onDeleteComment = (postId: string) => {
    openModal({
      title: t(MODALS.DELETE_COMMENT_TITLE),
      description: t(MODALS.DELETE_COMMENT_DESCRIPTION),
      okTitle: t(BUTTONS.DELETE) as string,
      onCancel: closeModal,
      onOk: () => onConfirmDeleteComment(postId),
    })
  }

  // useEffect(() => {
  //   unreadComments({ postId })
  // }, [newsFeedJumpData])

  const onNewComment = async () => {
    const cmnt = await onNewCommentForPost()
    if (cmnt) {
      setComments((prevState: FixMeLater) => {
        const isDuplicate = prevState.some((comment: FixMeLater) => comment._id === cmnt._id)
        if (isDuplicate) return prevState
        setTotalCommentCount(prev => prev + 1)
        return [cmnt, ...prevState]
      })
    }
  }

  useEffect(() => {
    if (pageNumber > 0) {
      fetchData()
    }
  }, [pageNumber])

  const [jumpToComment] = useLazyGetJumpedCommentsQuery()

  useEffect(() => {
    async function _fetchPageData() {
      if (comments.length && newsFeedJumpData) {
        let existInMyComments = false
        if (newsFeedJumpData?.commentId) {
          existInMyComments = comments.some(
            (comment: FixMeLater) => comment._id === newsFeedJumpData.commentId,
          )
          setReadyToScrollComment(existInMyComments)
        }
        if (!existInMyComments && newsFeedJumpData?.commentId) {
          await fetchJumpedComments()
        }
      }
    }
    _fetchPageData()
  }, [comments.length, newsFeedJumpData])

  useEffect(() => {
    setPageNumber(0)
    setComments([])
    fetchData(true)
  }, [postId])

  return (
    <Wrapper key={postId}>
      <Header
        backButton
        onJumpComment={onJumpComment}
        onCloseNotification={onCloseNotification}
        openNotifications={openNotifications}
        onToggleNotification={onToggleNotification}
      />
      {post && post.userData && (
        <PostWrapper className="post">
          <Post
            isPostDetail={true}
            postId={post?._id}
            data={post?.content}
            creatorInfo={post?.userData[post?.ownerId]}
            sentAt={post?.sentAt}
            status={post?.status}
            teamId={post?.teamName}
            isPostLoading={isPostLoading}
            myId={myId}
            likes={post?.likes}
            dislikes={post?.dislikes}
            users={post?.userData}
            commentCount={totalCommentCount}
            commentToggle={post?.commentToggle ?? true}
            onDeletePost={onDeletePost}
            onReactionPost={onReactionPost}
            onShowReactions={onShowReactions}
            onShowEditPostModal={onShowEditPostModal}
          />
          <Separator margin={{ top: 10, bottom: 10 }} />
          {post.commentToggle && (
            <>
              <CommonInputWrapper>
                {screenWidth > MOBILE_DEVICE_WIDTH && (
                  <Avatar
                    source={authUser.avatar}
                    text={authUser.fullname}
                    size={AvatarSize.medium}
                    type="circle"
                  />
                )}
                <CommonInput
                  data={commentInputData[postId]}
                  id={'comment'}
                  isValid={isValid}
                  placeHolder={t(POST.CREATE_COMMENT)}
                  onKeyDown={onKeyDown}
                  onMentionDropDown={setMentionsDropdown}
                  onNewCommentForPost={onNewComment}
                  onChangeInputData={onChangeInputData}
                  onSelectEmoji={onSelectEmoji}
                />
              </CommonInputWrapper>
              <Comments
                myId={myId}
                postId={post?.postId}
                commentPageIndex={commentPageIndex}
                comments={comments}
                totalCommentCount={totalCommentCount}
                readyToScrollComment={readyToScrollComment}
                onDeleteComment={onDeleteComment}
                onPagenateComment={setPageNumber}
                onShowEditPostModal={onShowEditPostModal}
                newsFeedJumpData={newsFeedJumpData}
                onResetNewsFeedJumpData={onResetNewsFeedJumpData}
              />
            </>
          )}
        </PostWrapper>
      )}
      {editPost.visible && (
        <EditPost
          avatar={authUser?.avatar}
          fullname={authUser?.fullname}
          post={editPost?.post}
          userInfo={authUser}
          onClose={onHideEditPostModal}
          onEditComment={fetchData}
        />
      )}
      {Modal}
      {reactions.visible && <PostReactions postId={reactions.postId} onClose={onHideReactions} />}
    </Wrapper>
  )
}
export default PostDetail

const Wrapper = styled.div`
  overflow: auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background-color: ${colors.light40};
  .post {
    width: 700px;
    @media only screen and (max-width: 800px) {
      width: 100%;
    }
  }
`

const PostWrapper = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.gray60};
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
  @media only screen and (min-width: ${MOBILE_DEVICE_WIDTH}px) {
    padding: 20px;
  }
  @media only screen and (max-width: ${MOBILE_DEVICE_WIDTH}px) {
    padding: 12px;
  }
`

const CommonInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 16px;
`
